import templateDefaults from '../templateDefaults';

const TGB_ASSETS_URL = process.env.TGB_ASSETS_CDN_URL;

export default {
  previewImage: '/img/sports/player-stats.png',
  title: 'Player Lower Third',
  templateData() {
    return {
      version: 'v1.1',
      title: 'Sports Player Lower Third',
      ...templateDefaults,
      elements: [
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Stat 3 Label',
          locked: false,
          text: '<p class="ql-align-center">RPG</p>',
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationYoyo: false,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: true,
          whiteSpace: 'normal',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 973,
            left: 1057,
            width: 64,
            height: 30,
            opacity: 1,
            color: '#000000',
            fontFamily: 'Roboto Condensed',
            textTransform: 'none',
            textDecoration: 'none',
            fontSize: 24,
            fontWeight: 'normal',
            fontStyle: 'normal',
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Stat 3',
          locked: false,
          text: '<p class="ql-align-center"><strong>36.7</strong><span class="ql-cursor">﻿</span></p>',
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationYoyo: false,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: true,
          whiteSpace: 'normal',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 965,
            left: 995,
            width: 72,
            height: 38,
            opacity: 1,
            color: '#000000',
            fontFamily: 'Roboto Condensed',
            textTransform: 'none',
            textDecoration: 'none',
            fontSize: 30,
            fontWeight: 'normal',
            fontStyle: 'normal',
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Stat 2 Label',
          locked: false,
          text: '<p class="ql-align-center">RPG</p>',
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationYoyo: false,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: true,
          whiteSpace: 'normal',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 973,
            left: 919,
            width: 64,
            height: 30,
            opacity: 1,
            color: '#000000',
            fontFamily: 'Roboto Condensed',
            textTransform: 'none',
            textDecoration: 'none',
            fontSize: 24,
            fontWeight: 'normal',
            fontStyle: 'normal',
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Stat 2',
          locked: false,
          text: '<p class="ql-align-center"><strong>36.7</strong><span class="ql-cursor">﻿</span></p>',
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationYoyo: false,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: true,
          whiteSpace: 'normal',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 965,
            left: 846,
            width: 88,
            height: 38,
            opacity: 1,
            color: '#000000',
            fontFamily: 'Roboto Condensed',
            textTransform: 'none',
            textDecoration: 'none',
            fontSize: 30,
            fontWeight: 'normal',
            fontStyle: 'normal',
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Stat 1 Label',
          locked: false,
          text: '<p class="ql-align-center">RPG</p>',
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationYoyo: false,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: true,
          whiteSpace: 'normal',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 973,
            left: 772,
            width: 64,
            height: 30,
            opacity: 1,
            color: '#000000',
            fontFamily: 'Roboto Condensed',
            textTransform: 'none',
            textDecoration: 'none',
            fontSize: 24,
            fontWeight: 'normal',
            fontStyle: 'normal',
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Stat 1',
          locked: false,
          text: '<p class="ql-align-center"><strong>36.7</strong><span class="ql-cursor">﻿</span></p>',
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationYoyo: false,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: true,
          whiteSpace: 'normal',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 965,
            left: 708,
            width: 70,
            height: 38,
            opacity: 1,
            color: '#000000',
            fontFamily: 'Roboto Condensed',
            textTransform: 'none',
            textDecoration: 'none',
            fontSize: 30,
            fontWeight: 'normal',
            fontStyle: 'normal',
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Team Name',
          locked: false,
          text: '<p class="ql-align-center">Team name here</p>',
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationYoyo: false,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: true,
          whiteSpace: 'normal',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 960,
            left: 258,
            width: 388,
            height: 30,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Roboto Condensed',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 24,
            fontWeight: 'normal',
            fontStyle: 'normal',
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Player State',
          locked: false,
          text: '<p class="ql-align-center">WA</p>',
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationYoyo: false,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: true,
          whiteSpace: 'normal',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 882,
            left: 1036,
            width: 62,
            height: 50,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Roboto Condensed',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 40,
            fontWeight: 'normal',
            fontStyle: 'normal',
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Player Number',
          locked: false,
          text: '<p class="ql-align-center">7<span class="ql-cursor">﻿</span></p>',
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationYoyo: false,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: true,
          whiteSpace: 'normal',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 882,
            left: 959,
            width: 62,
            height: 50,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Roboto Condensed',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 40,
            fontWeight: 'normal',
            fontStyle: 'normal',
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Player Name',
          locked: false,
          text: '<p><strong>PLAYER NAME</strong></p>',
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationYoyo: false,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: true,
          whiteSpace: 'normal',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 882,
            left: 575,
            width: 246,
            height: 50,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Roboto Condensed',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 40,
            fontWeight: 'normal',
            fontStyle: 'normal',
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Stat Label',
          locked: false,
          text: '<p><em>PLAYER STATS</em></p>',
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationYoyo: false,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: true,
          whiteSpace: 'normal',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 883,
            left: 240,
            width: 96,
            height: 49,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Roboto Condensed',
            textTransform: 'none',
            textDecoration: 'none',
            fontSize: 22,
            fontWeight: 'normal',
            fontStyle: 'normal',
          },
        },
        {
          version: 'v1',
          type: 'image',
          name: 'Player Headshot',
          editable: true,
          locked: false,
          aspectLock: true,
          mask: false,
          maskShape: 'oval',
          imageUrl: `${TGB_ASSETS_URL}/placeholders/player-headshot.png`,
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationYoyo: false,
          fillType: 'stretch',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          styles: {
            top: 701,
            left: 332,
            width: 220,
            height: 241,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'image',
          name: 'Team Logo',
          editable: true,
          locked: false,
          aspectLock: true,
          mask: false,
          maskShape: 'oval',
          imageUrl: `${TGB_ASSETS_URL}/logos/tagboard-hash-white.png`,
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationYoyo: false,
          fillType: 'stretch',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          styles: {
            top: 881,
            left: 155,
            width: 59,
            height: 53,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'image',
          name: 'Flare',
          editable: false,
          locked: false,
          aspectLock: true,
          mask: false,
          maskShape: 'oval',
          imageUrl: `${TGB_ASSETS_URL}/placeholders/flare.png`,
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationYoyo: false,
          fillType: 'stretch',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          styles: {
            top: 783,
            left: 409,
            width: 328,
            height: 178,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Blue Bar',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationYoyo: false,
          border: true,
          borderWidth: 5,
          borderColor: 'rgb(255, 255, 255)',
          boxShadow: true,
          boxShadowX: -4,
          boxShadowY: 4,
          boxShadowBlur: 17,
          boxShadowSpread: 1,
          boxShadowColor: 'rgba(0, 0, 0, 0.53)',
          fillStyle: 'solid',
          backgroundColor: 'rgb(3, 40, 117)',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 10,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 15,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          skewX: 30,
          skewY: 0,
          rotate: 0,
          styles: {
            top: 953,
            left: 236,
            width: 438,
            height: 44,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Yellow Bar',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationYoyo: false,
          border: true,
          borderWidth: 5,
          borderColor: 'rgb(255, 255, 255)',
          boxShadow: true,
          boxShadowX: -4,
          boxShadowY: 4,
          boxShadowBlur: 17,
          boxShadowSpread: 1,
          boxShadowColor: 'rgba(0, 0, 0, 0.53)',
          fillStyle: 'solid',
          backgroundColor: 'rgb(255, 238, 29)',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 10,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 15,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          skewX: 30,
          skewY: 0,
          rotate: 0,
          styles: {
            top: 953,
            left: 687,
            width: 438,
            height: 64,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Highlight',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationYoyo: false,
          border: false,
          borderWidth: 8,
          borderColor: 'rgb(255, 255, 255)',
          boxShadow: false,
          boxShadowX: -4,
          boxShadowY: 4,
          boxShadowBlur: 20,
          boxShadowSpread: 1,
          boxShadowColor: 'rgba(0, 0, 0, 0.52)',
          fillStyle: 'solid',
          backgroundColor: 'rgba(255, 255, 255, 0.22)',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          skewX: -30,
          skewY: 0,
          rotate: 0,
          styles: {
            top: 867,
            left: 140,
            width: 1000,
            height: 40,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Black Bar',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationYoyo: false,
          border: true,
          borderWidth: 5,
          borderColor: 'rgb(255, 255, 255)',
          boxShadow: true,
          boxShadowX: -4,
          boxShadowY: 4,
          boxShadowBlur: 20,
          boxShadowSpread: 1,
          boxShadowColor: 'rgba(0, 0, 0, 0.52)',
          fillStyle: 'solid',
          backgroundColor: 'rgb(0, 0, 0)',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 15,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 15,
          blur: false,
          blurSize: 10,
          skewX: -30,
          skewY: 0,
          rotate: 0,
          styles: {
            top: 867,
            left: 129,
            width: 1000,
            height: 80,
            opacity: 1,
          },
        },
      ],
    };
  },
};
